import React from "react";

import { Form, Input, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";

function AdditionalIncome({ additionalIncome, setAdditionalIncome }) {
    
  const addAdditionalIncome = () => {
    const newAdditionalIncome = {
      id: uuidv4(),
      monthlyIncome: "",
      source: "",
    };
    setAdditionalIncome([...additionalIncome, newAdditionalIncome]);
  };

  const removeAdditionalIncome = (id) => {
    const updatedAdditionalIncome = additionalIncome.filter(
      (item) => item.id !== id
    );
    setAdditionalIncome(updatedAdditionalIncome);
  };

  const handleChange = (value, name, id) => {
    const updatedAdditionalIncome = additionalIncome.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAdditionalIncome(updatedAdditionalIncome);
  };

  return (
    <ul>
      {additionalIncome.map((item) => (
        <li key={item.id}>
          <Form.Item label="">
            <Row>
              <Col span={8}>
                <Form.Item>
                  <Input
                    prefix="$"
                    onChange={(e) =>
                      handleChange(e.target.value, "monthlyIncome", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={15}>
                <Form.Item>
                  <Input
                    onChange={(e) =>
                      handleChange(e.target.value, "source", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={1}>
                {additionalIncome.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removeAdditionalIncome(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Form.Item>
        </li>
      ))}
      <Form.Item label="">
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addAdditionalIncome}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Income
        </Button>
      </Form.Item>
    </ul>
  );
}

export default AdditionalIncome;
